import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  getContactoPreferenciasById,
  getContactosById,
} from "api/Contacto.service"
import { ContactoConfiguracionReadingDtoProps } from "api/DTOs/ContactoConfiguracionReadingDto"
import { AnimatePresence } from "framer-motion"
import { useSelector } from "hooks/useSelector"
import { Skeleton } from "primereact/skeleton"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { EDITAR_CONTACTO } from "routes/RoutePaths"
import { globalSelector } from "routes/globalSlice"
import { FormikDocumentsProps } from "../../CreacionDocumento"
import {
  DOCUMENT_SCREEN,
  MODES_DOCUMENTOS,
  TYPES_DOCUMENTOS,
} from "../../constant"
import { FormasPago } from "../../hooks/ConvertirDocumento/ConvertirDocumento"
import CardConfiguracionDocumento from "../CardConfiguracionDocumento/CardConfiguracionDocumento"
import DropdownContactos from "../DropdownContactos/DropdownContactos"
import ModalJustificarFacturaRectificativa from "../ModalJustificarFacturaRectificativa/ModalJustificarFacturaRectificativa"
import ModalSucessCreateDocumento from "../ModalSucessCreateDocumento"
import ArticulosTableDocumento from "./Components/ArticulosTableDocumento/ArticulosTableDocumento"
import CardContactDocumento from "./Components/CardContactDocumento/CardContactDocumento"
import CardDocumentoAsociadoMsgDocumento from "./Components/CardDocumentoAsociadoMsgDocumento/CardDocumentoAsociadoMsgDocumento"
import CardFormaPagoDocumento from "./Components/CardFormaPagoDocumento/CardFormaPagoDocumento"
import CardObservacionesDocumento from "./Components/CardObservacionesDocumento/CardObservacionesDocumento"
import CardTotalesDocumento from "./Components/CardTotalesDocumento/CardTotalesDocumento"
import HeaderDatesLogoDocument from "./Components/HeaderDatesLogoDocument/HeaderDatesLogoDocument"
import HeaderDocumento from "./Components/HeaderDocumento/HeaderDocumento"
import FormDireccionFactura from "./Forms/ModalDireccionForm/ModalDireccionForm"

const FormDocumentoCompletoStage = ({
  values,
  setFieldValue,
  errors,
  handleSubmit,
  isSubmitting,
  handleChange,
  touched,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  const history = useHistory()
  const [showModalDireccion, setShowModalDireccion] = useState(
    values.documentoType.screen === DOCUMENT_SCREEN.FORM_COMPLETO &&
      !values.empresaActiva.direccion
  )
  const { formasPago } = useSelector(globalSelector)

  const addPreferences = ({
    descuento,
    diaDePago,
    formaPago,
    vencimientoDias,
  }: ContactoConfiguracionReadingDtoProps) => {
    const fechaVencimientoDate = new Date(values.fechaVencimiento)
    if (vencimientoDias) {
      fechaVencimientoDate.setDate(
        fechaVencimientoDate.getDate() + vencimientoDias
      )
    }

    const nuevaFechaVencimiento = fechaVencimientoDate.toISOString()
    if (values.documentoType.mode === MODES_DOCUMENTOS.VENTA) {
      if (descuento) setFieldValue("descuento", descuento)
      if (diaDePago) setFieldValue("diasPago", diaDePago)
      if (formaPago) {
        const formaPagoDescription = formasPago?.find(
          (forma: FormasPago) => formaPago === forma.id
        )?.description

        setFieldValue("formaPago", formaPago)
        setFieldValue("formaPagoDescription", formaPagoDescription)
      }
      if (vencimientoDias)
        setFieldValue("fechaVencimiento", nuevaFechaVencimiento)
    }
  }

  const [loadingContacto, setLoadingContacto] = useState(false)
  const handleContacto = async ({ value }: { value: string }) => {
    setLoadingContacto(true)
    const dataContact = await getContactosById(value)
    const dataContactPreferences = await getContactoPreferenciasById(value)
    setFieldValue("config.preferenceContat", dataContactPreferences)
    setFieldValue("librado.id", value)
    setFieldValue("librado", {
      id: value,
      ...dataContact,
      telefono: dataContact?.telefonos?.[0]?.contacto,
      email: dataContact?.emails?.[0]?.contacto,
    })
    addPreferences(dataContactPreferences)

    setLoadingContacto(false)
  }

  const handleEditClick = () => {
    const url: string = EDITAR_CONTACTO.replace(":id", values.librado.id)
    history.push(url)
  }

  const deleteLibrado = () => {
    setFieldValue("librado", null)
    setFieldValue("descuento", null)
    setFieldValue("diasPago", null)
    setFieldValue("formaPago", null)
    setFieldValue("formaPagoDescription", null)
    setFieldValue("fechaVencimiento", new Date())
  }

  return (
    <div className='tw-flex tw-flex-col tw-w-full tw-min-h-full'>
      <div className='tw-sticky tw-top-0 tw-z-10 tw-bg-white tw-w-full tw-h-fit tw-border-b tw-border-neutral-25 tw-shadow-sm'>
        <HeaderDocumento
          values={values}
          setFieldValue={setFieldValue}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
      </div>
      <section className='tw-flex-1 tw-overflow-y-auto tw-flex tw-flex-col xl:tw-flex-row tw-p-4 tw-bg-gray-50'>
        <div className='tw-flex tw-flex-col tw-bg-simple-10 tw-p-10 tw-flex-grow tw-shadow-md tw-rounded-xl xl:tw-rounded-l-xl xl:tw-rounded-r-none'>
          <HeaderDatesLogoDocument
            values={values}
            setFieldValue={setFieldValue}
            errors={errors}
          />
          <div className='tw-flex tw-flex-col md:tw-flex-row md:tw-gap-8 tw-mt-3'>
            <div className='tw-flex-1 tw-flex tw-flex-col tw-w-full'>
              <div
                style={{
                  backgroundColor: values.config.colorSelected,
                }}
                className='tw-w-full tw-h-12 tw-text-simple-10 tw-rounded-t-md tw-px-4 tw-flex tw-items-center'
              >
                {t("crear.facturaRec.supplierDataHeader")}
              </div>
              <CardContactDocumento
                data={values?.librador}
                setFieldValue={setFieldValue}
              />
            </div>
            <div className='tw-flex-1 tw-flex tw-flex-col tw-w-full'>
              <div
                style={{
                  backgroundColor: values.config.colorSelected,
                }}
                className={`${
                  values.librado ? "" : "tw-opacity-50"
                } tw-w-full !tw-h-12 tw-text-simple-10 tw-rounded-t-md tw-px-4 tw-flex tw-items-center tw-justify-between`}
              >
                {t("crear.facturaRec.clientDataHeader")}
                {values.documentoType.mode === MODES_DOCUMENTOS.VENTA &&
                  values.librado && (
                    <div className='tw-flex tw-flex-row'>
                      <div
                        className='hover:tw-text-secondary tw-w-8 tw-h-8 tw-rounded hover:!tw-border !tw-border-secondary tw-flex tw-items-center tw-justify-center tw-mr-3'
                        onClick={handleEditClick}
                      >
                        <FontAwesomeIcon
                          icon={["fal", "pen"]}
                          className='tw-w-4 tw-h-4 tw-cursor-pointer'
                        />
                      </div>
                      <div
                        className='hover:tw-text-danger tw-w-8 tw-h-8 tw-rounded hover:!tw-border !tw-border-danger tw-flex tw-items-center tw-justify-center'
                        onClick={deleteLibrado}
                      >
                        <FontAwesomeIcon
                          icon={["fal", "x"]}
                          className='tw-w-4 tw-h-4 tw-cursor-pointer'
                        />
                      </div>
                    </div>
                  )}
              </div>
              {values.librado ? (
                <CardContactDocumento
                  data={values?.librado}
                  setFieldValue={setFieldValue}
                  isLibrado
                />
              ) : loadingContacto ? (
                <div className='tw-flex tw-flex-col tw-mt-4 tw-h-fit tw-w-full'>
                  <div className='tw-p-2'>
                    <Skeleton height='28px' />
                  </div>
                  <div className='tw-p-2'>
                    <Skeleton height='28px' />
                  </div>
                  <div className='tw-p-2'>
                    <Skeleton height='28px' />
                  </div>
                  <div className='tw-p-2'>
                    <Skeleton height='28px' />
                  </div>
                  <div className='tw-p-2'>
                    <Skeleton height='28px' />
                  </div>
                </div>
              ) : (
                <div className='tw-flex tw-flex-col tw-px-2 tw-w-full tw-text-left'>
                  <p className='tw-m-0 tw-mt-6 tw-mb-2'>
                    {t("crear.facturaRec.selectClienteLabel")}
                  </p>

                  <DropdownContactos
                    values={values}
                    setFieldValue={setFieldValue}
                    onchange={handleContacto}
                  />
                </div>
              )}
            </div>
          </div>
          <div className='tw-w-full tw-max-w-full tw-mt-10 tw-overflow-x-scroll md:tw-overflow-hidden'>
            <ArticulosTableDocumento
              values={values}
              setFieldValue={setFieldValue}
            />
          </div>
          <div className='tw-flex tw-gap-8 tw-flex-col tw-items-end md:tw-flex-row tw-mt-10'>
            <div className='tw-flex tw-flex-col !tw-w-full md:!tw-w-1/2'>
              {values?.observaciones && (
                <CardObservacionesDocumento
                  observaciones={values.observaciones}
                  setShowObservacionesModal={() =>
                    setFieldValue("modals.showObservacionesModal", true)
                  }
                  colorSelected={values.config.colorSelected}
                />
              )}
              {(values?.formaPago || values?.diasPago > 0) &&
                values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA && (
                  <CardFormaPagoDocumento
                    values={values}
                    setShowFormaPagoModal={() =>
                      setFieldValue("modals.showFormaPagoModal", true)
                    }
                    setShowDiasPagoModal={() =>
                      setFieldValue("modals.showDiasPagoModal", true)
                    }
                    colorSelected={values.config.colorSelected}
                  />
                )}
              {values.documentosComercialesAsociados && (
                <CardDocumentoAsociadoMsgDocumento
                  documentosAsociadosMsg={
                    values?.documentosComercialesAsociados
                  }
                  colorSelected={values.config.colorSelected}
                />
              )}
            </div>
            {!values.config.sinValorar && (
              <div className='tw-w-1/2'>
                <CardTotalesDocumento
                  values={values}
                  setFieldValue={setFieldValue}
                />
              </div>
            )}
          </div>
        </div>
        <div className='tw-w-full tw-mt-0.5 xl:tw-mt-0 xl:tw-w-[400px] tw-p-10 tw-bg-simple-10 tw-shadow-md tw-ml-0.5 tw-rounded-xl xl:tw-rounded-r-xl xl:tw-rounded-l-none'>
          <CardConfiguracionDocumento
            values={values}
            setFieldValue={setFieldValue}
            touched={touched}
            handleChange={handleChange}
          />
        </div>
      </section>
      <AnimatePresence>
        <ModalSucessCreateDocumento
          key='modal-success-create-documento'
          values={values}
          setFieldValue={setFieldValue}
        />
        <ModalJustificarFacturaRectificativa
          key='modal-justificar-factura-rectificativa'
          values={values}
          setFieldValue={setFieldValue}
          handleSubmit={handleSubmit}
        />
        <FormDireccionFactura
          key='form-direccion-factura'
          visible={showModalDireccion}
          onHide={() => setShowModalDireccion(false)}
          empresaActivaId={values.empresaActiva.id}
          t={t}
          setFieldValueForm={setFieldValue}
          valuesForm={values}
        />
      </AnimatePresence>
    </div>
  )
}

export default FormDocumentoCompletoStage
